import "./styles/thankYou.scss";
import { useRef } from "react";
import Nav from "./Nav";

export default function ThankYou() {
  return (
    <main className="thank__main">
      <Nav />
      <h2>Thank You For Joining</h2>
      <h4>Our team will be in touch soon with the next steps</h4>
    </main>
  );
}
